import { useMemo } from 'react';

import useLocation from '../utils/useLocation';

export function useShouldForceMobileApp() {
  const { search } = useLocation();
  const query = useMemo(() => new URLSearchParams(search), [search]);
  return useMemo(() => query.get('shouldForceMobileApp') === 'true', [query]);
}
